import { EmploymentType } from "@/enums";

export default class Employment {
  public id: number;

  /**
   * The identifier of the employment period in the v3 employee API. Only set on employments loaded from it, which in
   * turn have no numeric `id`.
   */
  public uuid?: string;

  public employmentType: EmploymentType;

  public validFrom: string;

  public validTo: string;
}
